import { Link } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

import type { CookieConsent as CookieConsentValue } from '../../utils/cookieConsent'
import { readCookieConsent, writeCookieConsent } from '../../utils/cookieConsent'

export const CookieConsent = () => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (readCookieConsent() === null) setVisible(true)
    }, [])

    if (!visible) return null

    const handleChoice = (value: CookieConsentValue) => () => {
        writeCookieConsent(value)
        setVisible(false)
    }

    return (
        <div
            role="dialog"
            aria-label="Sütik használata"
            className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-2xl"
        >
            <div className="mx-auto flex max-w-[1280px] flex-col gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between">
                <div className="text-sm text-brand-gray">
                    <p className="font-bold text-brand-dark">Sütiket használunk</p>
                    <p className="mt-1">
                        Weboldalunk sütiket (cookie-kat) használ a szolgáltatás működtetéséhez és a
                        felhasználói élmény javításához. Részletekért látogasson el az{' '}
                        <Link
                            to="/privacy-policy"
                            className="font-semibold text-primary hover:underline"
                        >
                            adatvédelmi tájékoztatóra
                        </Link>
                        .
                    </p>
                </div>
                <div className="flex shrink-0 gap-3">
                    <button
                        type="button"
                        className="rounded-full border border-slate-300 px-5 py-2 text-sm font-bold text-brand-dark transition-colors hover:bg-slate-50"
                        onClick={handleChoice('rejected')}
                    >
                        Elutasítom
                    </button>
                    <button
                        type="button"
                        className="rounded-full bg-primary px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-primary/90"
                        onClick={handleChoice('accepted')}
                    >
                        Elfogadom
                    </button>
                </div>
            </div>
        </div>
    )
}
